import { AsyncPipe, NgClass, NgFor, NgIf } from '@angular/common';
import { NgModule } from '@angular/core';
import { SdvorDeliveryAddressModule } from './delivery/delivery-address.module';
import { SdvorPickupAddressModule } from './pickup/pickup-address.module';
import { SdvorReceiptAddressComponent } from './receipt-address.component';

@NgModule({
  imports: [NgIf, NgFor, AsyncPipe, NgClass, SdvorPickupAddressModule, SdvorDeliveryAddressModule],
  declarations: [SdvorReceiptAddressComponent],
  exports: [SdvorReceiptAddressComponent],
})
export class SdvorReceiptAddressModule {}
